import React from 'react';
import PropTypes from 'prop-types';

const PersonCheckYellowCircleIcon = ({ iconClasses }) => (
    <svg
        className={iconClasses}
        width="41"
        height="40"
        viewBox="0 0 41 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <circle cx="20.689" cy="20" r="20" fill="#FAD536" />
        <path
            d="M19.889 21.1429C17.6298 21.1429 15.6258 21.6289 14.309 22.0518C13.337 22.3649 12.689 23.2373 12.689 24.2149V27.2381H19.089"
            stroke="black"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M19.8889 21.1429V21.1429C17.6801 21.1429 15.8889 18.675 15.8889 16.5714V15.8095C15.8889 13.7059 17.6801 12 19.8889 12V12C22.0977 12 23.8889 13.7059 23.8889 15.8095V16.5714C23.8889 18.675 22.0977 21.1429 19.8889 21.1429Z"
            stroke="black"
            strokeLinecap="square"
        />
        <path
            d="M23.089 26.4762L24.689 28L28.689 24.1905"
            stroke="black"
            strokeLinecap="square"
        />
    </svg>
);

PersonCheckYellowCircleIcon.propTypes = {
    iconClasses: PropTypes.string,
};

export default PersonCheckYellowCircleIcon;
